export default({
    LOGIN_WITH_GOOGLE: "LOGIN_WITH_GOOGLE",
    TOKEN_FOR_GOOGLE: "TOKEN_FOR_GOOGLE"
})